import * as amplify from "../util/amplify.ts";
import * as INR from "../INR.ts";
import * as Html from "../util/Html.ts";
import * as modal from "../util/modal.ts";
import * as i18n from "../i18n.ts";

import {OS} from "../lib/os.ts"
import ApiServer from "../ApiServer.ts";
import * as FwDatas from "../FwDatas.ts";
import "../util/taskutil.ts";
import "../ui/modal/listCategories.ts";
import "./taskQuickAdd.ts";
import * as actionMenu from  "../widget/action-menu-registry.ts"
import {ControllerBook} from "../page/ControllerBook.ts";
import {MetaTaskCache, TaskCache, TaskListCache} from "../server/objects/TaskBeans.ts"
import * as FeatureSeen from "../util/FeatureSeen.ts";

import TPL_tasklist from "../list/tasklist.mustache";
import TPL_notasklist from "../list/tasklist-empty.mustache";
import Icons from "../svg/Icons.ts";
import { checkTaskSoftLimit } from "./list_clean.ts";


actionMenu.register({
  tasklistitemmenu(){
    var
      buttons : actionMenu.ActionMenuButton[] = [],
      metaId = Html.getDomMetaId(this),
      taskListBean = TaskListCache.get(metaId);

    if(taskListBean.pinSortingIndex===null){
      buttons.push({onclick:'taskpinlist|true',svg:Icons.list.ic_pin,i18nkey:'actions.pin',permission:"listPinable",clickFunctionNoPermission:pinlistpremium})
    }else{
      buttons.push({onclick:'taskpinlist|false',svg:Icons.list.ic_unpin,i18nkey:'actions.unpin',permission:"listPinable",clickFunctionNoPermission:pinlistpremium})
    }
    if(taskListBean.rights.canUpdate){
      buttons.push({onclick:'listedit',svg:Icons.list.ic_list_edit,i18nkey:'catsystem.edit'})
    }
    if(taskListBean.mightsort){
      buttons.push({onclick:'togglemenu',svg:Icons.ic_sort,i18nkey:'catsystem.sort.title',
        submenu:[
          {
            onclick:'tasklistsort|alphabetical',
            svg:Icons.ic_sorting_alphabetically,
            i18nkey:'catsystem.sort.alphabetical',
            svgend:taskListBean.taskSorting==='alphabetical'||taskListBean.taskSorting==='alphabeticalReverse'?Icons.ic_checkmark:undefined
          },
          {
            onclick:'tasklistsort|duedate',
            svg:Icons.calendar.ic_plan_recipe,
            i18nkey:'catsystem.sort.duedate',
            svgend:taskListBean.taskSorting==='duedate'||taskListBean.taskSorting==='duedateReverse'?Icons.ic_checkmark:undefined
          },
          {
            onclick:'tasklistsort|creationdate',
            svg:Icons.ic_sorting_creation_date,
            i18nkey:'catsystem.sort.creationdate',
            svgend:taskListBean.taskSorting==='creationdate'||taskListBean.taskSorting==='creationdateReverse'?Icons.ic_checkmark:undefined
          },
          {
            onclick:'tasklistsort|byrecipe',
            svg:Icons.ic_recipes,i18nkey:'catsystem.sort.byrecipe',
            svgend:taskListBean.taskSorting==='byrecipe'||taskListBean.taskSorting==='byrecipeReverse'?Icons.ic_checkmark:undefined
          },
          {
            onclick:'tasklistsort|custom',
            svg:Icons.ic_sorting_custom,i18nkey:'catsystem.sort.custom',
            svgend:taskListBean.taskSorting==='custom'?Icons.ic_checkmark:undefined
          }
        ]})
    }
    buttons.push({onclick:'tasklistcategorymanage',svg:Icons.list.ic_category_manage,i18nkey:'catsystem.categorymanage'})
    if(taskListBean.taskCategoriesHidden){
      buttons.push({onclick:'tasklistcategoryhide|false',svg:Icons.list.ic_category_show,i18nkey:'catsystem.categoryshow'})
    }else{
      buttons.push({onclick:'tasklistcategoryhide|true',svg:Icons.list.ic_category_hide,i18nkey:'catsystem.categoryhide'})
    }
    if(!taskListBean.system && taskListBean.rights.canShare){
      buttons.push({onclick:'listeditsharing',svg:Icons.ic_group,i18nkey:'catsystem.editsharing'})
    }
    if(taskListBean.completedHidden){
      buttons.push({onclick:'listshowhidecompleted|false',svg:Icons.list.ic_completed_show,i18nkey:'catsystem.completedshow'})
    }else{
      buttons.push({onclick:'listshowhidecompleted|true',svg:Icons.list.ic_completed_hide,i18nkey:'catsystem.completedhide'})
    }
    if(taskListBean.ongoing.length){
      buttons.push({onclick:'taskmarkall',svg:Icons.list.ic_checked,i18nkey:'catsystem.mark'})
    }
    if(taskListBean.complete.length){
      buttons.push({onclick:'taskunmarkall',svg:Icons.list.ic_checkbox,i18nkey:'catsystem.unmark'})
      buttons.push({onclick:'taskdeletemarked',svg:Icons.list.ic_delete_ticked,i18nkey:'catsystem.clean'})
    }
    buttons.push({onclick:'taskduplicatelist',svg:Icons.ic_duplicate,i18nkey:'catsystem.duplicate'})
    buttons.push({onclick:'print',svg:Icons.ic_print,i18nkey:'actions.print'});


    buttons.push({
      permission:taskListBean.system?"listSystemDeletable":undefined,
      clickFunctionNoPermission:systemlistdeletepremium,
      onclick:taskListBean.rights.canDelete?'listdelete':'notadminmodal',
      svg:Icons.ic_delete,i18nkey:'actions.delete',color:'var(--red)'
    })

    if(OS.canShare){
      buttons.push({onclick:'listshare',svg:Icons.ic_send,i18nkey:'actions.send'})
    }
    return {'menu':buttons}
  },
  async tasklistmenu(){
    return {'menu':[{onclick:'listcreate',svg:Icons.ic_add_plus,i18nkey:'catsystem.create'}]}
  }

})

function systemlistdeletepremium(){
  modal.needpremium({
    title:"listclean.premium.title",
    message:"listclean.premium.message",
  })
}
function pinlistpremium(){
  modal.needpremium({
    title:"catsystem.premium.title",
    message:"catsystem.premium.message",
  })
}


Html.registerDom({
  taskpinlist(value){
    if(FwDatas.getPermission('listPinable')==='KO_PREMIUM'){
      pinlistpremium()
      return false
    }
    const
      metaId = Html.getDomMetaId(this),
      list = FwDatas.get(metaId);
    ApiServer.taskpinlist(metaId,value);
    if(value==='true'){
      modal.toast({
        text:i18n.get('catsystem.toastpin',list),
        svg:Icons.list.ic_pin
      })

    }else{
      modal.toast({
        text:i18n.get('catsystem.toastunpin',list),
        svg:Icons.list.ic_unpin
      })
    }
    amplify.publish('taskNeedRefresh')
    return false
  },
  featureseenpin(){
    FeatureSeen.markSeen('tasklist.pin')
    amplify.publish('taskNeedRefresh')
  },
  featureseendeletesystem(){
    FeatureSeen.markSeen('tasklist.deletesystem')
    amplify.publish('taskNeedRefresh')
  }
})

INR.onPage(INR.URL.TASKS,async function(){
  INR.subscribe("CommentChanged",function(isInit){
    amplify.publish("taskNeedRefresh")
  })
  INR.subscribe("pageUnload",function(){
    ApiServer.taskcloselist();
  })
  var CONTROLLER = new ControllerBook(
    document.querySelector('.pane-left'),
    await import("../list/tasklist_list.mustache"),
    document.querySelector('.pane-main'),
    TPL_tasklist,
    TPL_notasklist,
    TaskListCache,
    function(allitems){
      var
        n = 0,
        p = 0,
        s = 0,
        pinned = [],
        unpinned = [];

      allitems.sort((a,b)=>b.lastActionDate-a.lastActionDate)
      allitems.forEach(taskList=>{
        n++;
        if(taskList.isShared()) s++;
        else p++;
        if(taskList.pinSortingIndex!==null){
          pinned.push(taskList)
        }else{
          unpinned.push(taskList)
        }
      })
      pinned.sort((a,b)=>b.pinSortingIndex-a.pinSortingIndex)

      return {
        items:allitems,
        pinned,
        unpinned,
        countInfo:{n:n,p:p,s:s},
        showfeaturepin:!FeatureSeen.hasSeen('tasklist.pin'),
        showfeaturedeletesystem:hasSeenPinOnSessionStart && !FeatureSeen.hasSeen('tasklist.deletesystem')}
    }
  );
  INR.subscribe("taskRefreshed",CONTROLLER.onRefresh)
  amplify.publish("taskNeedRefresh")

  checkTaskSoftLimit()

});
var hasSeenPinOnSessionStart = FeatureSeen.hasSeen('tasklist.pin')